import ComponentType from "@/enums/ComponentType";
import FieldType from "@/enums/FieldType";

const Heading = {
  type: ComponentType.IMAGE,
  name: "image",
  settings: {
    src: {
      type: FieldType.IMAGE_URL
    }
  }
};

export default Heading;